import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Dont = makeShortcode("Dont");
const Caption = makeShortcode("Caption");
const Do = makeShortcode("Do");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Background colors should be limited to the colors provided in the template.`}</p>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/55435593-0a97ab00-554f-11e9-83b1-74aa14dd7411.png",
        "alt": "Examples of slides using the background colors (black, white, blue, purple, yellow) from the template"
      }}></img></p>
    <h4>{`Usage guidelines`}</h4>
    <DoDontContainer mdxType="DoDontContainer">
  <Dont mdxType="Dont">
    <img alt="slide with octocat logo and a red to yellow to purple radial gradient behind it" src="https://user-images.githubusercontent.com/10384315/54648119-40726500-4a62-11e9-95cc-f2798867dfd6.png" />
    <Caption mdxType="Caption">Don't use gradients or colors outside the provided template</Caption>
  </Dont>
  <Dont mdxType="Dont">
    <img alt="slide with octocat logo on top of a star tiled background" src="https://user-images.githubusercontent.com/10384315/54648132-4d8f5400-4a62-11e9-9445-25016320e1fd.png" />
    <Caption mdxType="Caption">Don't use tiled images</Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Background images`}</h2>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/55435514-e0de8400-554e-11e9-9376-42cebd3c1c83.png",
        "alt": "Section Title - Hubot"
      }}></img></p>
    <p>{`Background images should be used `}<em parentName="p">{`only`}</em>{` to support, not to distract the viewers. Lower the opacity of a background image to maintain readability.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img alt="slide with the background dimmed with black to highlight the white text" src="https://user-images.githubusercontent.com/10384315/54647253-06539400-4a5f-11e9-8315-f14eefee699f.png" />
    <Caption mdxType="Caption">Background images should be dimmed to 25% opacity</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img width="500" alt="slide without dimming over a background image and unreadable white text" src="https://user-images.githubusercontent.com/10384315/54647119-a9f07480-4a5e-11e9-93c1-29d6116b8492.png" />
    <Caption mdxType="Caption">Don't use busy background images when paired with text</Caption>
  </Dont>
    </DoDontContainer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      